/* PTD — chatgpt-ads : le systeme du hero (coins de coupe + defile + pulse)
   repris tel quel dans la zone d'impression du studio, SANS la barre.

   v6 — retours d'Elie du 08/10 :
     - reprendre le systeme de la landing (defile, pulse) tel quel
     - « sans la barre » = sans #hero-cta, la barre Pose ta photo / OU / Generer
       du hero. Le bouton bleu, lui, reste.
     - le texte natif « Ajouter une photo » derriere est masque : le bouton
       est devant, les deux faisaient doublon
     - le bouton tient sur UNE ligne
     - l'accroche « Apercu instantane... » est retiree

   Donc on ne reimite plus : on reutilise les classes du theme.
     .rep .tl/.tr/.bl/.br  -> coins de coupe (styles-suite.liquid l.411-416)
     .zone.cale .rep       -> le pulse, coins qui s'ecartent de 5px (l.417-420)
     .zone.sur  .rep       -> survol, coins bleus ecartes de 9px (l.421-425)
     .defile / .defile img -> boite + visuels, animations presse/releve (l.428-444)
   Aucun de ces styles n'est redefini ici : seul le positionnement est
   reecrit, parce que le hero cale .zone et .defile sur ses propres variables
   (--zx/--zy/--zw/--zh et --fx/--fy/--fw/--fh) alors qu'ici la boite est
   #st-zone, la vraie zone d'impression du support choisi.

   Visuels et cadence : repris de la page elle-meme (tableau DESIGNS de
   ptd.js, {src, taille}) avec la meme sequence que aller() du hero et la
   meme duree (1500 ms, 6000 ms si l'utilisateur a reduit les animations).

   Pas de bouton, pas d'accroche : « sans la barre ». La zone reste
   cliquable et accepte le glisser-deposer, comme .zone dans le hero.

   Scope : uniquement les sessions utm_source=chatgpt-ads (A, arrivee accueil)
   et chatgpt-ads-studio (B, arrivee directe dans le studio) — test A/B du 11/10/2026. */
(function(){
  'use strict';

  var src = (function(){
    try { var s = sessionStorage.getItem('ptd_src'); if (s) return s; } catch(e){}
    var m = location.search.match(/[?&]utm_source=([^&]+)/);
    if (m) {
      var v = decodeURIComponent(m[1]).toLowerCase();
      try { sessionStorage.setItem('ptd_src', v); } catch(e){}
      return v;
    }
    /* pages suivantes : la source memorisee par _source() de ptd.js */
    try { return sessionStorage.getItem('ptd-src') || ''; } catch(e){}
    return '';
  })();
  if (window.PTD_APERCU_ASSETS) return; /* 26/10/2026 : remplace par ptd-arrivee-apercu.js */
  if (src !== 'chatgpt-ads' && !/-studio$/.test(src)) return; /* 15/10/2026 : toute source finissant par -studio (liens partenaires) */

  var MOINS_ANIME = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var DUREE = MOINS_ANIME ? 6000 : 1500;   /* la cadence du hero */
  var PULSE = 300;                          /* duree de .cale dans le hero */

  /* Les visuels : ceux de la page. DESIGNS est un let de premier niveau d'un
     script classique, donc visible par nom nu, pas via window (cf. CLAUDE.md).
     Repli sur la liste figee si l'ordre des scripts change un jour. */
  function visuels(){
    /* 11/10/2026 : la liste pilotee depuis #admin (Worker /visuels-liste) passe d'abord, comme dans le hero. */
    try { var L = window.PTD_VISUELS_DYN; if (L && L.length) return L; } catch(e){}
    try { if (typeof DESIGNS !== 'undefined' && DESIGNS && DESIGNS.length) return DESIGNS; } catch(e){}
    var PA = window.PTD_ASSETS || {};
    var A = '/cdn/shop/t/2/assets/';
    var F = 'https://cdn.shopify.com/s/files/1/0961/7598/0810/files/';
    return [
      {src:A+'ptd-design-photo-bebe-coeur.webp?v=1791323721', taille:.72},
      {src:A+'ptd-ia-chat-vintage.webp?v=1791323721',         taille:.8},
      {src:A+'ptd-design-photo-pelouse.webp?v=1791323721',    taille:.72},
      {src:PA.designGoodVibes || '',                          taille:1},
      {src:PA.designLovelove || '',                           taille:1},
      {src:A+'ptd-design-manga-duo3.webp?v=1791323721',       taille:.88},
      {src:F+'ptd-design-ton-design-3d.webp?v=1791291203',    taille:.88},
      {src:A+'ptd-ia-chat-halo.webp?v=1791323721',            taille:.8},
      {src:F+'ptd-design-polaroid.webp?v=1790804532',         taille:.8},
      {src:A+'ptd-design-photo-saut.webp?v=1791323721',       taille:.72},
      {src:A+'ptd-design-chien.webp?v=1791323721',            taille:.8},
      {src:A+'ptd-design-shiba-japon.webp?v=1791323721b',     taille:.8},
      {src:A+'ptd-design-warhol-duo.webp?v=1791323721',       taille:.86},
      {src:A+'ptd-design-maman.webp?v=1791323721',            taille:.82},
      {src:A+'ptd-design-micky.webp?v=1791323721',            taille:.8},
      {src:A+'ptd-ia-amour.webp?v=1791323721',                taille:.8},
      {src:A+'ptd-design-warhol-quad.webp?v=1791323721',      taille:.92},
      {src:A+'ptd-ia-team-mariee.webp?v=1791323721',          taille:.88},
      {src:A+'ptd-ia-chat-affiche.webp?v=1791323721',         taille:.84},
      {src:A+'ptd-design-ecusson.webp?v=1791323721',          taille:.95}
    ].filter(function(o){ return !!o.src; });
  }

  /* l'icone du bouton de depot du hero (#bouton-depot), reprise telle quelle :
     tracees pleines (fill), pas des contours. */
  var ICONE_UPLOAD = '<svg viewBox="0 0 24 24" aria-hidden="true" width="18" height="18" fill="currentColor">' +
    '<path d="M12 3.6 6.9 8.7l1.4 1.4 2.7-2.7V16h2V7.4l2.7 2.7 1.4-1.4z"/>' +
    '<path d="M5 17.4v1.2c0 .9.7 1.6 1.6 1.6h10.8c.9 0 1.6-.7 1.6-1.6v-1.2h-2v.8H7v-.8z"/></svg>';

  /* Uniquement du positionnement pour .rep / .defile : ils gardent leurs
     bordures, leurs transitions et leurs animations du theme.
     Le bouton, lui, est a nous (celui du hero fait partie de la barre). */
  var css = document.createElement('style');
  css.id = 'ptd-ads-css';
  css.textContent =
    /* Zoom (loupe) : la boite reprend le contenu de la scene, mes accroches et
       mon bouton s'y retrouvaient empiles par-dessus le produit. On les masque. */
    '.st-loupe-in .ptd-ads-scene,.st-loupe-in .ptd-ads-cta,' +
      '.st-loupe-boite .ptd-ads-scene,.st-loupe-boite .ptd-ads-cta{display:none !important}' +
    '#st-zone.ptd-ads-actif{outline:none !important}' +
    /* Les 4 coins delimitent un CARRE, pas le rectangle de la zone : cote = la
   plus grande des deux dimensions de #st-zone. La zone d'impression etant en
   portrait, le carre y gagne en largeur. #st-zone est deja un
   container-type:size (styles-suite l.1285), donc cqw/cqh s'y referent. */
    '#st-zone .ptd-ads-scene{position:absolute; left:50%; top:50%;' +
      'transform:translate(-50%,-54%); width:100%; aspect-ratio:1;' +   /* repli */
      'z-index:3; cursor:pointer; -webkit-tap-highlight-color:transparent}' +
/* Coins un poil plus fins que dans le hero (2,4px) : la zone du studio est
   plus petite, le trait y pesait trop. Seul le studio est touche. */
    '#st-zone .ptd-ads-scene .rep{border-width:1.3px}' +
    '@supports (width:1cqw){#st-zone .ptd-ads-scene{' +
      'width:max(100cqw,100cqh); height:max(100cqw,100cqh); aspect-ratio:auto}}' +
    /* retour Elie : les visuels remontent un peu dans le carre */
    '#st-zone .ptd-ads-scene .defile{position:absolute; left:0; top:0; width:100%; height:100%;' +
      'transform:translateY(-3%); z-index:1; pointer-events:none}' +
    /* Le « Ajouter une photo » natif passe derriere le bouton : on le masque.
       .st-vide est une carte posee au centre (styles-suite l.901-908 : bordure
       pointillee + fond). Le hero n'a pas de cadre, juste les coins : on rend
       donc la carte entierement transparente et inerte, sans la sortir du flux
       — le studio continue de basculer son attribut [hidden], que l'on observe. */
    '#st-vide.ptd-ads-actif{border-color:transparent !important; background:transparent !important;' +
      'box-shadow:none !important; backdrop-filter:none !important; -webkit-backdrop-filter:none !important}' +
    /* 15/10/2026 supports chien : zone d'impression petite et vetement fonce -> defile agrandi, coins blancs */
    '#st-zone .ptd-ads-scene.ptd-ads-chien{width:calc(max(100cqw,100cqh)*1.45); height:calc(max(100cqw,100cqh)*1.45); aspect-ratio:auto}' +
    '#st-zone .ptd-ads-scene.ptd-ads-chien .rep{border-color:rgba(255,255,255,.92)}' +
    '#st-zone .ptd-ads-scene.ptd-ads-chien .ptd-ads-cta{top:calc(100% + 30px)}' +
    '#st-vide.ptd-ads-actif:hover{transform:translate(-50%,-50%) !important}' +
    '#st-vide.ptd-ads-actif > *{visibility:hidden}' +
    '@keyframes ptd-ads-bat{' +
      '0%{transform:translate(-50%,-50%) scale(1);box-shadow:0 0 0 0 rgba(40,40,232,.38),0 6px 18px rgba(40,40,232,.3)}' +
      '55%{transform:translate(-50%,-50%) scale(1.07);box-shadow:0 0 0 14px rgba(40,40,232,0),0 6px 18px rgba(40,40,232,.3)}' +
      '100%{transform:translate(-50%,-50%) scale(1);box-shadow:0 0 0 0 rgba(40,40,232,0),0 6px 18px rgba(40,40,232,.3)}}' +
    /* Le bouton se pose SOUS la zone d'impression, jamais par-dessus le visuel :
   sur telephone la zone est petite et il mordait sur le dessin. #st-zone est
   un container-type:size, qui ne rogne pas le debordement — le bouton reste
   visible sur le vetement, sous les coins de coupe. */
    '#st-zone .ptd-ads-scene .ptd-ads-cta{position:absolute; left:50%; top:100%; z-index:5;' +
      'display:inline-flex; align-items:center; gap:9px; white-space:nowrap;' +
      'background:#2828e8; border:none; border-radius:999px; padding:17px 26px;' +
      'color:#fff; font:600 15px/1 Jost,system-ui,sans-serif; letter-spacing:.2px;' +
      'cursor:pointer; transform:translate(-50%,-50%); will-change:transform;' +
      'animation:ptd-ads-bat 2.4s cubic-bezier(.4,0,.2,1) infinite}' +
    '#st-zone .ptd-ads-scene .ptd-ads-cta > span{white-space:nowrap}' +
    /* le picto etait ecrase par le flex : on lui impose sa taille */
    '#st-zone .ptd-ads-scene .ptd-ads-cta svg{flex:0 0 auto; width:17px; height:17px;' +
      'fill:currentColor; display:block}' +
    '#st-zone .ptd-ads-scene .ptd-ads-cta:hover,#st-zone .ptd-ads-scene .ptd-ads-cta:focus-visible{background:#1f1fd0;animation-play-state:paused}' +
    '@media (max-width:760px){#st-zone .ptd-ads-scene .ptd-ads-cta{font-size:13.5px; padding:14px 20px; gap:7px; transform:translate(-50%,-18%)}}' +
    '@media (prefers-reduced-motion: reduce){#st-zone .ptd-ads-scene .ptd-ads-cta{animation:none}}' +

    /* ---- Mobile ----------------------------------------------------------
       Ces trois reglages passent par CETTE feuille, injectee a l'execution,
       parce que snippets/styles-suite.liquid n'atteint pas la page (verifie :
       meme ses propres regles d'origine sont absentes du HTML servi).
       Contrepartie : seuls les visiteurs chatgpt-ads en beneficient. */

    /* 1. Le bouton recouvrait les deux accroches du bas et mordait sur le
          visuel : plus petit, et descendu sous leur axe. L'animation imposant
          son propre transform, il lui faut ses propres images-cles. */
    '@keyframes ptd-ads-bat-m{' +
      '0%{transform:translate(-50%,14%) scale(1);box-shadow:0 0 0 0 rgba(40,40,232,.38),0 5px 14px rgba(40,40,232,.3)}' +
      '55%{transform:translate(-50%,14%) scale(1.06);box-shadow:0 0 0 7px rgba(40,40,232,0),0 5px 14px rgba(40,40,232,.3)}' +
      '100%{transform:translate(-50%,14%) scale(1);box-shadow:0 0 0 0 rgba(40,40,232,0),0 5px 14px rgba(40,40,232,.3)}}' +
    '@media (max-width:760px){' +
      '#st-zone .ptd-ads-scene .ptd-ads-cta{font-size:12px; padding:9px 14px; gap:5px;' +
        'transform:translate(-50%,14%); animation-name:ptd-ads-bat-m}' +
      /* Sorti de la carte : .st-scene est en overflow:hidden ET mise a l'echelle.
         Safari rogne alors ses descendants au rectangle d'AVANT transformation,
         ce qui coupait net le bord droit de la pastille. */
      /* Le bouton change de parent : il faut lui redonner TOUT son habillage,
         l'ancien selecteur (#st-zone .ptd-ads-scene .ptd-ads-cta) ne s'applique
         plus une fois qu'il est rattache a .st-vue. */
      '.st-vue>.ptd-ads-cta{position:absolute; z-index:6;' +
        'display:inline-flex; align-items:center; justify-content:center;' +
        'gap:6px; white-space:nowrap;' +
        'background:#2828e8; border:none; border-radius:999px; padding:11px 20px;' +
        'color:#fff; font:600 13px/1 Jost,system-ui,sans-serif; letter-spacing:.2px;' +
        'cursor:pointer; will-change:transform; transform:translateX(-50%);' +
        'animation:ptd-ads-bat-mv 2.4s cubic-bezier(.4,0,.2,1) infinite}' +
      '.st-vue>.ptd-ads-cta>span{white-space:nowrap}' +
      '.st-vue>.ptd-ads-cta svg{flex:0 0 auto; width:15px; height:15px;' +
        'fill:currentColor; display:block}' +
      '.st-vue>.ptd-ads-cta:hover,.st-vue>.ptd-ads-cta:focus-visible{background:#1f1fd0}' +
      '@keyframes ptd-ads-bat-mv{' +
        '0%{transform:translateX(-50%) scale(1);box-shadow:0 0 0 0 rgba(40,40,232,.38),0 5px 14px rgba(40,40,232,.3)}' +
        '55%{transform:translateX(-50%) scale(1.06);box-shadow:0 0 0 8px rgba(40,40,232,0),0 5px 14px rgba(40,40,232,.3)}' +
        '100%{transform:translateX(-50%) scale(1);box-shadow:0 0 0 0 rgba(40,40,232,0),0 5px 14px rgba(40,40,232,.3)}}' +
      '#st-zone .ptd-ads-scene .ptd-ads-cta svg{width:14px; height:14px}' +

    /* 2. Le rail des teintes bascule a l'horizontale sous le vetement : la
          largeur qu'il occupait a droite revient au visuel. */
'}';
  (document.head || document.documentElement).appendChild(css);

  function brancherDepot(scene, fichier){
    ['dragenter','dragover'].forEach(function(ev){
      scene.addEventListener(ev, function(e){ e.preventDefault(); scene.classList.add('sur'); });
    });
    ['dragleave','drop'].forEach(function(ev){
      scene.addEventListener(ev, function(e){ e.preventDefault(); scene.classList.remove('sur'); });
    });
    scene.addEventListener('drop', function(e){
      e.preventDefault();
      var f = e.dataTransfer && e.dataTransfer.files && e.dataTransfer.files[0];
      if (!f || !fichier) return;
      try {
        var dt = new DataTransfer();
        dt.items.add(f);
        fichier.files = dt.files;
        fichier.dispatchEvent(new Event('change', { bubbles: true }));
      } catch(err){}
    });
    /* comme .zone dans le hero : survol + clic */
    scene.addEventListener('mouseenter', function(){ scene.classList.add('sur'); });
    scene.addEventListener('mouseleave', function(){ scene.classList.remove('sur'); });
    scene.addEventListener('click', function(){ if (fichier) fichier.click(); });
  }

  function peupler(vide){
    if (vide.dataset.ptdAds === '1') return;
    var zoneEl = document.getElementById('st-zone');
    if (!zoneEl) return;
    vide.dataset.ptdAds = '1';
    vide.classList.add('ptd-ads-actif');
    zoneEl.classList.add('ptd-ads-actif');

    /* classe "zone" pour heriter du pulse .zone.cale .rep et du survol .zone.sur .rep */
    var scene = document.createElement('div');
    scene.className = 'zone ptd-ads-scene';
    scene.setAttribute('role', 'button');
    scene.setAttribute('tabindex', '0');
    scene.setAttribute('aria-label', 'Pose ta photo');

    ['tl','tr','bl','br'].forEach(function(c){
      var r = document.createElement('span');
      r.className = 'rep ' + c;
      scene.appendChild(r);
    });

    var d = document.createElement('div');
    d.className = 'defile';
    d.setAttribute('aria-hidden', 'true');

    /* construction identique a vues = DESIGNS.map(...) du hero */
    var liste = visuels();
    var vues = liste.map(function(o, k){
      var im = new Image();
      im.src = o.src;
      im.alt = '';
      im.decoding = 'async';
      if (o.taille > 0){
        /* +15 % demande, mais plafonne a 86 % du carre : au-dela les plus
           grands visuels (taille 1) debordaient et touchaient les accroches. */
        var t = (Math.min(o.taille * 1.15, 0.86) * 100).toFixed(2) + '%';
        im.style.inset = '0';
        im.style.margin = 'auto';
        im.style.width = t;
        im.style.height = t;
      }
      if (k > 0) im.loading = 'lazy';
      d.appendChild(im);
      return im;
    });

    scene.appendChild(d);
    zoneEl.appendChild(scene);
    function chien(){ var m = document.getElementById('st-mock'); scene.classList.toggle('ptd-ads-chien', !!(m && /teechien|sweatchien/.test(m.getAttribute('src') || ''))); }
    chien();
    try { var mk = document.getElementById('st-mock'); if (mk) new MutationObserver(chien).observe(mk, { attributes: true, attributeFilter: ['src'] }); } catch(e){}

    var fichier = document.getElementById('fichier');
    brancherDepot(scene, fichier);

    var cta = document.createElement('button');
    cta.type = 'button';
    cta.className = 'ptd-ads-cta';
    /* meme libelle que le bouton du hero, et le verbe de la marque :
   « Essaie ta photo » faisait porter l'essai sur la photo, pas sur le produit. */
    cta.innerHTML = ICONE_UPLOAD + '<span>Pose ta photo</span>';
    cta.addEventListener('click', function(e){
      e.stopPropagation();
      if (fichier) fichier.click();
    });
    var mobile = window.matchMedia && window.matchMedia('(max-width:760px)').matches;
    var vueEl = document.querySelector('.st-vue');
    if (mobile && vueEl) vueEl.appendChild(cta); else scene.appendChild(cta);

    /* meme sequence que aller(k) dans le hero */
    var i = -1, minuteur = null;
    function aller(k){
      if (!scene.isConnected || vide.hidden){ clearTimeout(minuteur); return; }
      if (i >= 0 && i !== k){
        vues[i].classList.remove('entre', 'on');
        vues[i].classList.add('sort');
      }
      i = k;
      vues.forEach(function(v, j){ if (j !== i) v.classList.remove('on', 'entre'); });
      var n = vues[i];
      n.classList.remove('sort');
      n.offsetWidth;                       /* reflow, comme dans le hero */
      n.classList.add('entre', 'on');
      scene.classList.add('cale');
      setTimeout(function(){ scene.classList.remove('cale'); }, PULSE);
      minuteur = setTimeout(function(){ aller((i + 1) % vues.length); }, DUREE);
    }
    if (vues.length) aller(0);

    /* 11/10/2026 A/B : variante A (chatgpt-ads) arrive sur l'accueil et choisit
       elle-meme son produit, on ne lui impose pas la teinte ; variante B
       (chatgpt-ads-studio) retrouve le demarrage d'avant, sur « Sable ». */
    if (src === 'chatgpt-ads-studio') teinteDepart();
    surveillerLoupe();

    scene._ptdStop = function(){ clearTimeout(minuteur); };
  }

  /* Demarrage sur le tee-shirt creme — « Sable » dans le rail .st-teintes.
     Une seule fois par session : si le visiteur choisit ensuite une autre
     couleur, on ne la lui reprend pas. */
  var teinteFaite = false;
  function teinteDepart(){
    if (teinteFaite) return;
    try { if (sessionStorage.getItem('ptd-ads-teinte')) { teinteFaite = true; return; } } catch(e){}
    var essais = 0;
    var tic = setInterval(function(){
      var b = document.querySelector('.st-teintes .tnt[title="Sable"]');
      if (b){
        clearInterval(tic);
        teinteFaite = true;
        try { sessionStorage.setItem('ptd-ads-teinte', '1'); } catch(e){}
        if (b.getAttribute('aria-pressed') !== 'true') b.click();
      } else if (++essais > 40) clearInterval(tic);
    }, 150);
  }

  /* Le rail des teintes est un frere de .st-scene, positionne sur .st-vue :
     selon la hauteur de l'ecran il tombait tantot sous la carte, tantot
     par-dessus le vetement — « on dirait deux blocs distincts ». On le cale
     donc DANS la carte, en bas et centre sur elle, a partir des rectangles
     reels (getBoundingClientRect tient compte du scale applique a .st-scene,
     contrairement a offsetWidth). */
  var railTimer = null;
  function calerRail(){
    if (!window.matchMedia || !window.matchMedia('(max-width:760px)').matches) return;
    var vue = document.querySelector('.st-vue');
    var carte = document.querySelector('.st-vue>.st-scene');
    var rail = document.getElementById('st-teintes');
    if (!vue || !carte) return;
    var sansRail = !rail || !rail.children.length;
    var v = vue.getBoundingClientRect(), c = carte.getBoundingClientRect();
    if (sansRail){ /* pas de teintes : on place quand meme le bouton */
      var cs = vue.querySelector(':scope > .ptd-ads-cta');
      if (cs && c.height && c.width && v.width){ var bs = cs.getBoundingClientRect().height || 38;
        cs.style.setProperty('left', (c.left - v.left + c.width / 2) + 'px', 'important');
        cs.style.setProperty('top', (c.top - v.top + c.height - 14 - bs) + 'px', 'important'); }
      return;
    }
    var h = rail.getBoundingClientRect().height || 29;
    /* un rectangle transitoire (0 de large/haut) donnait un rail cale tout
       a gauche, hors de l'ecran : on ne touche a rien dans ce cas. */
    if (!c.height || !c.width || !v.width) return;
    rail.classList.add('ptd-ads-rail');
    rail.style.setProperty('left', (c.left - v.left + c.width / 2) + 'px', 'important');
    rail.style.setProperty('top',  (c.top - v.top + c.height - h - 4) + 'px', 'important');
    rail.style.setProperty('bottom', 'auto', 'important');

    var cta = vue.querySelector(':scope > .ptd-ads-cta');
    if (cta){
      var bh = cta.getBoundingClientRect().height || 38;
      cta.style.setProperty('left', (c.left - v.left + c.width / 2) + 'px', 'important');
      cta.style.setProperty('top',  (c.top - v.top + c.height - h - 14 - bh) + 'px', 'important');
    }
  }
  function surveillerRail(){
    calerRail();
    [60, 200, 600, 1200].forEach(function(d){ setTimeout(calerRail, d); });
    if (railTimer) return;
    /* En continu, independamment de l'ecran vide : le rail suit le support
       meme une fois la photo posee, et se recorrige si la mise en page bouge. */
    railTimer = setInterval(calerRail, 500);
    ['resize','orientationchange'].forEach(function(ev){
      addEventListener(ev, function(){ setTimeout(calerRail, 80); });
    });
    try {
      var vue = document.querySelector('.st-vue');
      if (vue && window.ResizeObserver) new ResizeObserver(function(){ calerRail(); }).observe(vue);
    } catch(e){}
  }

  /* Le zoom (loupe) reprend la scene. Mes surcharges y rendaient la carte
     native transparente et masquaient mon bouton : plus rien n'etait cliquable
     et l'affichage etait casse. On retire donc simplement mes classes tant que
     la loupe est ouverte — tout mon habillage est accroche a .ptd-ads-actif,
     l'etat natif revient entier, clic compris. */
  var loupeTimer = null;
  function surveillerLoupe(){
    if (loupeTimer) return;
    var etait = false;
    loupeTimer = setInterval(function(){
      var el = document.querySelector('.st-loupe-in, .st-loupe-boite');
      var ouverte = !!(el && el.getBoundingClientRect().height > 50);
      if (ouverte === etait) return;
      etait = ouverte;
      var vide = document.getElementById('st-vide');
      var zone = document.getElementById('st-zone');
      if (ouverte){
        if (vide) vide.classList.remove('ptd-ads-actif');
        if (zone) zone.classList.remove('ptd-ads-actif');
      } else if (vide && vide.dataset.ptdAds === '1' && !vide.hidden){
        vide.classList.add('ptd-ads-actif');
        if (zone) zone.classList.add('ptd-ads-actif');
        calerRail();
      }
    }, 350);
  }

  function rendreRail(){
    var rail = document.getElementById('st-teintes');
    if (!rail) return;
    rail.classList.remove('ptd-ads-rail');
    ['left','top','bottom'].forEach(function(k){ rail.style.removeProperty(k); });
  }

  function nettoyer(vide){
    /* On ne rend PAS le rail a sa colonne d'origine : il doit rester cale en
       bas du support, centre dessus, qu'il y ait une photo ou non. */
    vide.dataset.ptdAds = '';
    vide.classList.remove('ptd-ads-actif');
    var zoneEl = document.getElementById('st-zone');
    if (!zoneEl) return;
    zoneEl.classList.remove('ptd-ads-actif');
    Array.prototype.forEach.call(
      document.querySelectorAll('#st-zone .ptd-ads-scene, #st-zone .ptd-ads-cta, .st-vue>.ptd-ads-cta'),
      function(n){ try { n._ptdStop && n._ptdStop(); } catch(e){} n.remove(); });
  }

  function surveiller(){
    var vide = document.getElementById('st-vide');
    if (!vide) return false;
    if (!vide.hidden) peupler(vide);
    try {
      new MutationObserver(function(muts){
        muts.forEach(function(m){
          if (m.attributeName === 'hidden'){
            if (!vide.hidden) peupler(vide); else nettoyer(vide);
          }
        });
      }).observe(vide, { attributes: true, attributeFilter: ['hidden'] });
    } catch(e){}
    return true;
  }

  var tries = 0;
  var poll = setInterval(function(){
    if (surveiller() || ++tries > 100) clearInterval(poll);
  }, 150);
})();


/* ---------------------------------------------------------------------------
   Mise en page mobile du studio — POUR TOUS LES VISITEURS, pas seulement
   la campagne. Demande d'Elie du 08/10 : « sur mobile sur tout je veux que tu
   centres en bas la barre de couleur au support et tu laisses en grand la zone
   du support ».

   Pourquoi ici et pas dans assets/ptd-suite.css : la position du rail depend
   du rectangle reel de la carte, qui est mise a l'echelle. Une regle CSS seule
   ne sait pas ou tombe ce rectangle ; il faut le mesurer. Le reste (l'echelle
   de la carte) est bien de la CSS pure.
   --------------------------------------------------------------------------- */
(function(){
  'use strict';
  if (!window.matchMedia || !window.matchMedia('(max-width:760px)').matches) return;

  var css = document.createElement('style');
  css.id = 'ptd-studio-mobile';
  css.textContent =
    '@media (max-width:760px){' +
      /* La carte recupere la place libre a droite. transform:scale et non une
         largeur : le studio calcule #st-zone en JS d'apres le mock, une mise a
         l'echelle fait grandir le vetement ET sa zone d'impression ensemble. */
      /* La colonne de gauche retrecit ; la taille de la carte, elle, n'est PAS
         ecrite en dur : elle est calculee a l'execution (voir calerCarte). */
      /* 30/10/2026 (Elie, piste B validee) : plus de colonne de vignettes, la carte prend la place ;
         couleurs en colonne verticale au bord droit de la carte ; 4 tags de styles IA qui tournent en bas ;
         barre noire plus fine ; plus de ligne de styles ; taille sur une ligne ; barre d'achat allegee. */
      /* 30/10/2026 22h (Elie, test valide « c'est pas mal ») : la zone du support EN PLEIN — plus de carte arrondie dans la
         zone, le fond prend la couleur de la photo du support (--ptd-fond) ; petite colonne de TOUS les supports a gauche
         (30 px, on peut cliquer), defile avec un fondu s'il y en a trop ; couleurs collees au bord droit. */
      'html body .st-vue{background:var(--ptd-fond,#fff) !important}' +
      'html body .st-vue>.st-scene{border-radius:0 !important;box-shadow:none !important;border:0 !important;background:var(--ptd-fond,#fff) !important}' +
      'html body #studio .st-vue>.st-mini{display:flex !important;flex-direction:column !important;position:absolute !important;z-index:6;left:4px !important;top:54px !important;bottom:8px !important;width:36px !important;max-height:none !important;padding:0 !important;gap:5px !important;background:transparent !important;box-shadow:none !important;backdrop-filter:none !important;-webkit-backdrop-filter:none !important;border-radius:0 !important;overflow-y:auto !important;overflow-x:hidden !important;scrollbar-width:none}' +
      'html body #studio .st-vue>.st-mini.ptd-deborde{-webkit-mask-image:linear-gradient(#000 84%,transparent);mask-image:linear-gradient(#000 84%,transparent)}' +
      'html body .st-vue>.st-mini::-webkit-scrollbar{display:none}' +
      'html body #studio .st-vue>.st-mini .mini{width:36px !important;min-height:0 !important;padding:1px !important;border:1.5px solid #E2E2E7 !important;border-radius:8px !important;flex:0 0 auto !important;background:#fff !important;transform:none !important}' +
      'html body #studio .st-vue>.st-mini .mini.on{border-color:#14161A !important;box-shadow:none !important}' +
      'html body #studio .st-vue>.st-mini .mini-n{display:none !important}' +
      'html body #studio .st-vue>.st-mini .mini-v{border-radius:6px !important}' +
      /* 30/10 22h37 (Elie) : onglets remis « comme avant », dans des bulles noires (plus lisible) */
      '.st-vue>#st-teintes.ptd-droite{right:auto !important; bottom:auto !important; transform:translateY(-50%) !important;' +
        'flex-direction:column !important; flex-wrap:nowrap !important; gap:6px !important; padding:6px 4px !important;' +
        'border-radius:999px !important; background:rgba(255,255,255,.92) !important; box-shadow:0 4px 14px rgba(20,20,40,.12) !important;' +
        'width:auto !important; max-width:none !important; max-height:78% !important; overflow-y:auto !important; overflow-x:hidden !important; scrollbar-width:none !important}' +
      '.st-vue>#st-teintes.ptd-droite::-webkit-scrollbar{display:none}' +
      '.st-vue>#st-teintes.ptd-droite .tnt{width:16px !important; height:16px !important; flex:0 0 auto !important; margin:0 !important}' +
      '#ptd-tags{position:absolute; z-index:6; display:flex; gap:6px; transform:translateX(-50%); transition:opacity .35s ease; white-space:nowrap; pointer-events:auto}' +
      '#ptd-tags.off{opacity:0}' +
      '#ptd-tags button{border:1px solid rgba(20,22,40,.10); background:#fff; color:#16161d; border-radius:999px; padding:6px 10px; margin:0; transition:opacity .35s; font:500 11.5px/1 Jost,system-ui,-apple-system,sans-serif;' +
        'box-shadow:0 4px 12px rgba(20,20,40,.14),0 1px 2px rgba(20,20,40,.08); display:inline-flex; gap:4px; align-items:center; cursor:pointer; -webkit-tap-highlight-color:transparent}' +
      'html body .st-bar{min-height:44px !important} html body .st-pan{min-height:44px !important; font-size:12.5px !important} html body .st-logo img{height:15px !important}' +
      'html body #st-sty2{display:none !important}' +
      'html body .st-tarif .st-liv{display:none !important} html body #st-ajouter{white-space:nowrap !important}' +
      '#st-bloc-taille.ptd-1l{display:flex !important; align-items:center !important; gap:6px !important; flex-wrap:nowrap !important}' +
      '#st-bloc-taille.ptd-1l #st-ss-taille{display:contents !important}' +
      '#st-bloc-taille.ptd-1l .ptd-tl{font-weight:500; font-size:13px; margin-right:2px; white-space:nowrap}' +
      '#st-bloc-taille.ptd-1l .st-guide{order:3; margin-left:auto !important; font-size:11.5px !important; white-space:nowrap}' +
      '#st-bloc-taille.ptd-1l #st-tailles{order:2; display:flex !important; flex-wrap:nowrap !important; gap:5px !important; margin:0 !important}' +

      /* Le rail des teintes passe a l'horizontale, cale en bas de la carte. */
      '.st-vue>#st-teintes.ptd-bas{right:auto !important; top:auto !important;' +
        'transform:translateX(-50%) !important;' +
        'flex-direction:row !important; flex-wrap:nowrap !important;' +
        'gap:7px !important; padding:5px 9px !important; border-radius:999px !important;' +
        'max-width:92% !important; overflow-x:auto !important}' +
      '.st-vue>#st-teintes.ptd-bas .tnt{width:19px !important; height:19px !important}' +
    '}';
  (document.head || document.documentElement).appendChild(css);

  function caler(){
    if (loupeOuverte()) return;
    var vue = document.querySelector('.st-vue');
    var carte = document.querySelector('.st-vue>.st-scene');
    var rail = document.getElementById('st-teintes');
    if (!vue || !carte) return;
    var sansRail = !rail || !rail.children.length;
    var v = vue.getBoundingClientRect(), c = carte.getBoundingClientRect();
    if (sansRail){ /* pas de teintes : on place quand meme le bouton */
      var cs = vue.querySelector(':scope > .ptd-ads-cta');
      if (cs && c.height && c.width && v.width){ var bs = cs.getBoundingClientRect().height || 38;
        cs.style.setProperty('left', (c.left - v.left + c.width / 2) + 'px', 'important');
        cs.style.setProperty('top', (c.top - v.top + c.height - 14 - bs) + 'px', 'important'); }
      if (c.height && c.width && v.width) tagsPlacer(vue, v, c);
      return;
    }
    var h = rail.getBoundingClientRect().height || 29;
    /* rectangle transitoire : on ne touche a rien, sinon le rail part hors ecran */
    if (!c.height || !c.width || !v.width) return;
    rail.classList.remove('ptd-bas'); rail.classList.add('ptd-droite');
    var rw = rail.getBoundingClientRect().width || 24;
    rail.style.setProperty('left', (v.width - rw - 4) + 'px', 'important'); /* 30/10 22h : au bord droit de l'ecran, plus sur le vetement */
    rail.style.setProperty('top',  (c.top - v.top + c.height / 2 + 6) + 'px', 'important');
    rail.style.setProperty('bottom', 'auto', 'important');
    h = 0; /* le rail n'occupe plus le bas de la carte */

    /* Le bouton de la campagne vit lui aussi dans .st-vue (sorti de la carte a
       cause du rognage Safari) : sa position se calcule ici, avec le meme
       rectangle. Sans ca il reste colle a gauche, au milieu du vetement. */
    var cta = vue.querySelector(':scope > .ptd-ads-cta');
    if (cta){
      var bh = cta.getBoundingClientRect().height || 38;
      cta.style.setProperty('left', (c.left - v.left + c.width / 2) + 'px', 'important');
      cta.style.setProperty('top',  (c.top - v.top + c.height - h - 14 - bh) + 'px', 'important');
    }
    tagsPlacer(vue, v, c);
  }

  /* 30/10/2026 — tags de styles IA en bas de la carte : 4 a la fois, ils tournent toutes les 3 s ;
     un toucher ouvre « Photo & IA » avec ce style deja choisi (rien n'est genere, aucun cout IA). */
  var STY = [['🎌','manga'],['🦸','comics'],['🎨','aquarelle'],['💥','popart'],['😄','cartoon'],['✏️','trait']];
  /* 30/10/2026 22h09 (Elie : « manga, pop art, trait fin, BD ; après on alterne, en mode random ; manga et pop art on les laisse ») */
  var FIXES = [['🎌','manga'],['💥','popart']], TOUR = [['✏️','trait'],['🦸','comics'],['🎨','aquarelle'],['😄','cartoon']], PAIRE = [0, 1];
  function nouvellePaire(){ var a, b, n = 0; do { a = Math.floor(Math.random() * TOUR.length); b = Math.floor(Math.random() * TOUR.length); n++; } while ((a === b || (a === PAIRE[0] && b === PAIRE[1]) || (a === PAIRE[1] && b === PAIRE[0])) && n < 20); PAIRE = [a, b]; }
  var tagDebut = 0, tagT = null;
  function T_(x){ try { return window.TT ? window.TT(x) : x; } catch(e){ return x; } }
  function nomStyle(id){
    var fr = /^fr/i.test(document.documentElement.lang || 'fr');
    if (id === 'comics' && fr) return 'BD';
    var b = document.querySelector('.ia-sty[data-st="' + id + '"] span');
    var t = b && b.textContent.trim();
    if (t) return t;
    return {manga:'Manga',comics:'BD',aquarelle:'Aquarelle',popart:'Pop art',cartoon:'Cartoon',trait:'Trait fin'}[id];
  }
  function tagsRemplir(el){
    var html = '';
    var L4 = FIXES.concat([TOUR[PAIRE[0]], TOUR[PAIRE[1]]]);
    for (var i = 0; i < 4; i++){ var s = L4[i];
      html += '<button type="button" data-st="' + s[1] + '"><span aria-hidden="true">' + s[0] + '</span>' + nomStyle(s[1]) + '</button>'; }
    el.innerHTML = html;
  }
  function tagChoisir(st){
    try { var S = window.__ptdS; S && S.cpt && S.cpt('geste', { support: 'tag_style_' + st }); } catch(e){}
    /* 02/11/2026 Elie : la pastille lance l'effet directement, SANS basculer sur l'onglet « Photo & IA », avec le meme chargement que sur ordinateur (bandeau « Ta photo passe en … » + barre) */
    if (document.getElementById('s2-msg')) return;
    var b = document.querySelector('.ia-sty[data-st="' + st + '"]'); if (b) b.click();
    var av = document.getElementById('st-ia-avec'); if (av && !av.checked) av.click();
    var sc = document.getElementById('st-scene'), m = null;
    if (sc){ var l = (document.documentElement.lang || 'fr').slice(0,2);
      var MSG = {fr:'✨ Ta photo passe en {s}…',en:'✨ Turning your photo into {s}…',de:'✨ Dein Foto wird zu {s}…',nl:'✨ Je foto wordt {s}…',es:'✨ Tu foto se vuelve {s}…',it:'✨ La tua foto diventa {s}…',pt:'✨ A tua foto passa a {s}…'};
      m = document.createElement('div'); m.id = 's2-msg'; m.setAttribute('role','status'); m.innerHTML = '<b></b><i></i>';
      m.querySelector('b').textContent = (MSG[l] || MSG.en).replace('{s}', nomStyle(st)); sc.appendChild(m); }
    var t0 = Date.now(), vu = false;
    setTimeout(function(){ try { var go = document.getElementById('st-ia-go'); if (go && !go.disabled) { go.click(); try { var S = window.__ptdS; S && S.cpt && S.cpt('geste', { support: 'tag_style_go', d: st }); } catch(e){} } } catch(e){} }, 150);
    var iv = setInterval(function(){ try { var go = document.getElementById('st-ia-go'), occ = !!(go && go.disabled), dt = Date.now() - t0; if (occ) vu = true;
      if ((vu && !occ) || (!vu && dt > 3500) || dt > 90000){ clearInterval(iv); m && m.remove(); } } catch(e){ clearInterval(iv); m && m.remove(); } }, 300);
  }
  function tagsPlacer(vue, v, c){
    var el = document.getElementById('ptd-tags');
    if (!el){
      el = document.createElement('div'); el.id = 'ptd-tags'; el.setAttribute('aria-label', T_('Essaie un style'));
      tagsRemplir(el);
      ['pointerdown','touchstart','mousedown'].forEach(function(t){ el.addEventListener(t, function(e){ e.stopPropagation(); }); });
      el.addEventListener('click', function(e){ var b = e.target.closest('button[data-st]'); if (!b) return; e.preventDefault(); e.stopPropagation(); tagChoisir(b.getAttribute('data-st')); });
      vue.appendChild(el);
      var calme = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (!calme) tagT = setInterval(function(){
        if (document.hidden) return;
        var bs = el.querySelectorAll('button'); [bs[2], bs[3]].forEach(function(b){ if (b) b.style.opacity = '0'; });
        setTimeout(function(){ nouvellePaire(); tagsRemplir(el); }, 360);
      }, 3200);
    }
    var cta = vue.querySelector(':scope > .ptd-ads-cta');
    var ctaVisible = !!(cta && cta.getBoundingClientRect().height > 0 && getComputedStyle(cta).display !== 'none');
    /* 30/10 — Elie : « pas besoin de mettre les tags avant qu'il y ait une photo » : un style transforme une photo,
       donc les pastilles n'apparaissent qu'une fois la photo du client posee (originale ou source du studio). */
    var aPhoto = false;
    try { var et = window.__ptdS && __ptdS.etat; aPhoto = !!(et && (et.originale || et.source)); } catch (e) {}
    el.style.display = (ctaVisible || !aPhoto) ? 'none' : 'flex';
    var th = el.getBoundingClientRect().height || 26;
    el.style.left = (v.width / 2) + 'px'; /* 30/10 22h (Elie) : centrees sur l'ecran */
    el.style.top = (c.top - v.top + c.height - th - 10) + 'px';
  }

  /* 30/10/2026 — « Taille », les tailles et « Guide » sur une seule ligne (seulement pour des tailles S a 2XL). */
  function tailleUneLigne(){
    var bl = document.getElementById('st-bloc-taille'), lab = document.getElementById('st-ss-taille'), pi = document.getElementById('st-tailles');
    if (!bl || !lab || !pi) return;
    var cle = pi.getAttribute('data-cle') || '';
    var ok = /^(XS\|)?S\|M(\||$)/.test(cle);
    /* le bloc est cache par le studio pour les objets sans taille (mug, tote...) : on ne le force jamais visible */
    bl.classList.remove('ptd-1l');
    if (bl.hidden || getComputedStyle(bl).display === 'none') ok = false;
    if (ok) bl.classList.add('ptd-1l');
    if (!ok || lab.querySelector('.ptd-tl')) return;
    var a = lab.querySelector('a');
    [].slice.call(lab.childNodes).forEach(function(n){ if (n !== a) lab.removeChild(n); });
    var sp = document.createElement('span'); sp.className = 'ptd-tl'; sp.textContent = T_('Taille');
    lab.insertBefore(sp, a || null);
    if (a){ a.setAttribute('aria-label', a.textContent.trim()); a.textContent = T_('Guide'); }
  }

  /* 30/10/2026 — Elie : « pour la fleche retour tu as pas un autre picto ? » puis « il faut une fleche de retour » :
     une vraie fleche (←, avec sa tige) a la place du chevron, meme action (revenir en arriere). */
  /* 30/10 11h52 — Elie envoie le picto voulu : fleche de retour en U. 12h06 : « garder la meme esthetique que les deux
     pictos a droite » (partager, loupe) : trait de 2,1, bouts ronds, sans remplissage, 22 px. */
  var FLECHE = '<svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="2.1" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M8.5 14.5 3 9l5.5-5.5"/><path d="M3.5 9H15a5.5 5.5 0 0 1 0 11h-4.5"/></svg>';
  function iconeRetour(){
    var r = document.getElementById('c25-retour');
    if (!r || r.getAttribute('data-ic') === 'retour-u2') return;
    r.innerHTML = FLECHE; r.setAttribute('data-ic', 'retour-u2');
  }

  /* La carte s'adapte a l'ecran au lieu d'une echelle ecrite en dur : on mesure
     la bande reellement libre entre la colonne de gauche et le bord droit, et on
     met la carte a l'echelle pour l'occuper. Valable sur n'importe quelle largeur
     — SE, Pro Max, Android — et recalcule a la rotation. */
  var MARGE = 6;

  /* Le zoom reutilise .st-scene : si on y laisse notre mise a l'echelle, le
     vetement deborde de la boite et recouvre la ligne de prix. Tant que la
     loupe est ouverte on rend la carte intacte et on ne touche plus a rien. */
  function loupeOuverte(){
    var el = document.querySelector('.st-loupe-in, .st-loupe-boite');
    return !!(el && el.getBoundingClientRect().height > 50);
  }

  function calerCarte(){
    var vue = document.querySelector('.st-vue');
    var carte = document.querySelector('.st-vue>.st-scene');
    var mini = document.querySelector('.st-vue>.st-mini');
    var rail = document.getElementById('st-teintes');
    if (!vue || !carte) return;
    if (loupeOuverte()){
      carte.style.removeProperty('transform');
      carte.style.removeProperty('transform-origin');
      return;
    }

    /* mesure sans transformation, pour connaitre la taille et la place naturelles */
    var avant = carte.style.transform;
    carte.style.transform = 'none';
    var v = vue.getBoundingClientRect();
    var c0 = carte.getBoundingClientRect();
    var m = mini ? mini.getBoundingClientRect() : null;
    if (!c0.width || !c0.height || !v.width){ carte.style.transform = avant; return; }

    var gauche = MARGE; /* 30/10 22h : la petite colonne flotte dans la marge de la photo, la carte reste centree */
    var droite = v.width - MARGE;
    var largeur = droite - gauche;
    var hRail = rail ? (rail.getBoundingClientRect().height || 29) : 0;
    var hauteur = v.height - 2 * MARGE;

    var s = Math.min(largeur / c0.width, hauteur / c0.height);
    if (!isFinite(s) || s < 1) s = 1;
    if (s > 1.6) s = 1.6;

    var centreNaturel = (c0.left - v.left) + c0.width / 2;
    var centreVise = gauche + largeur / 2;
    carte.style.transformOrigin = 'center center';
    carte.style.transform = 'translateX(' + Math.round(centreVise - centreNaturel) + 'px) scale(' + s.toFixed(3) + ')';
  }

  var FOND = {"bougie": "#BEB1A8", "boule": "#CEC0B8", "calendrier": "#F3F1ED", "calendrier30": "#F3F1ED", "carte": "#F7F6F2", "coque": "#E5E5E5", "gourde": "#D5D2D3", "mugvoyage": "#DCDCDC", "teechien": "#E3DCD4", "toile": "#FAFBF8", "toile2030": "#FAFBF8", "toile3030": "#FAFBF8"};
  function fondZone(){
    try {
      var vue = document.querySelector('.st-vue'); if (!vue) return;
      var id = (window.__ptdS && __ptdS.etat && __ptdS.etat.support) || '';
      var f = FOND[id] || '#fff';
      if (vue.style.getPropertyValue('--ptd-fond') !== f) vue.style.setProperty('--ptd-fond', f);
      var m = document.querySelector('.st-vue>.st-mini');
      if (m) m.classList.toggle('ptd-deborde', m.scrollHeight > m.clientHeight + 4 && m.scrollTop + m.clientHeight < m.scrollHeight - 4);
    } catch(e){}
  }
  /* 31/10/2026 02h40 — LAG MOBILE mesure (telephone moyen simule) : ce minuteur recalculait toute la mise en page de la carte
     toutes les 0,5 s (transform remis a zero puis 3 mesures = mise en page forcee), soit ~1,6 s de blocage sur 8 s sans rien toucher.
     On ne recale plus que si quelque chose a change (taille d'ecran, support, loupe, taille de la carte, rail), et par securite toutes les 10 s. */
  var _sigC = '', _kC = 0;
  setInterval(function(){
    try {
      var vue = document.querySelector('.st-vue'), carte = document.querySelector('.st-vue>.st-scene'), rail = document.getElementById('st-teintes');
      var sig = innerWidth + 'x' + innerHeight + '|' + ((window.__ptdS && __ptdS.etat && __ptdS.etat.support) || '') + '|' + (loupeOuverte() ? 1 : 0) + '|' +
        (vue ? vue.clientWidth + 'x' + vue.clientHeight : '-') + '|' + (carte ? carte.offsetWidth + 'x' + carte.offsetHeight : '-') + '|' + (rail ? rail.children.length : 0) + '|' +
        (document.querySelector('.st-vue > .ptd-ads-cta') ? 1 : 0);
      if (sig !== _sigC || ++_kC % 20 === 0) { _sigC = sig; calerCarte(); caler(); }
    } catch(e){ calerCarte(); caler(); }
    tailleUneLigne(); iconeRetour(); fondZone();
  }, 500);
  calerCarte();
  ['resize','orientationchange'].forEach(function(ev){
    addEventListener(ev, function(){ setTimeout(function(){ calerCarte(); caler(); }, 80); });
  });
  caler();
})();
